import { useState, useCallback } from "react";
import debounce from "lodash/debounce";
import { IoCloseSharp } from "react-icons/io5";
import { useSelector } from "react-redux";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import GeneralButton from "../button/GeneralButton";
import { CustomerDropdown } from "../dropdown/DropDown";
import { getAllVendors } from "../../api/pagination";
const AddReturnVendorSelection = ({ modal, toggle, setShippingData }) => {
  const { all_vendors } = useSelector((state) => state.orders);
  const [data, setData] = useState(null);
  const [searchVendors, setSearchVendors] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const handleVendor = (val) => {
    let res =
      searchVendors &&
      searchVendors?.find((i, index) => {
        return index === Number(val);
      });
    if (res) {
      let obj = {
        ...res?.billing[0],
        quickbooks_id: res?.quickbooks_id,
      };

      setData(obj);
    }
  };
  const fetchPOsDebounced = useCallback(
    debounce((searchText) => {
      getAllVendors(1, searchText, 50, (res) => {
        if (res) {
          setSearchVendors(res?.data?.data);
        }
        setDataLoading(false);
      });
    }, 500),
    []
  );

  const handleSearchPO = (searchText) => {
    setDataLoading(true);
    fetchPOsDebounced(searchText);
  };
  const handleShippingData = () => {
    setShippingData(data);
    toggle();
  };
  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      centered
      onClosed={() => {
        console.log("ujello");
      }}
    >
      <ModalBody className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5 className="primary-color">Select Vendor Info</h5>
          <IoCloseSharp size={"30"} onClick={toggle} />
        </div>
        <Row className="mb-3">
          <Col md={12}>
            <CustomerDropdown
              width={"100%"}
              label={"Select Vendor"}
              placeholder={"Select"}
              object_key={"customer"}
              showSearch
              options={searchVendors?.length > 0 ? searchVendors : all_vendors}
              onSelect={(val) => {
                handleVendor(val);
              }}
              height="45px "
              customClassName={" mb-2 w-100"}
              loading={dataLoading}
              onSearch={handleSearchPO}
            />
          </Col>
          <div className="d-flex justify-content-end">
            <GeneralButton
              title={"Cancel"}
              className={"bg-white text-black border-1 mx-2"}
              width={"100px"}
              handleClick={toggle}
            />
            <GeneralButton
              title={"Continue"}
              className={"bg-primary-color border-0"}
              width={"100px"}
              handleClick={() => {
                handleShippingData();
              }}
            />
          </div>
        </Row>
      </ModalBody>
    </Modal>
  );
};
export default AddReturnVendorSelection;
